import { CssStyles } from '../../core/models/css-styles-model';

export abstract class LinearLoaderModel implements CssStyles {
  id?: string;
  mode?: string;
  messages?: Array<LinearLoaderMessageModel>;
  hidden?: boolean;
  value?: number;
  background?: string;
  fillColor?: string;
  fontColor?: string;
  fontFamily?: string;
  fontWeight?: number;
}

export interface LinearLoaderMessageModel {
  message?: string;
  delay?: number;
  duration?: number;
}
